/* eslint-disable react-refresh/only-export-components */
import { createFileRoute } from '@tanstack/react-router';
import { EntityCertificationsTab } from '@/app/(client)/my-styles/-components/EntityCertificationsTab';
import { entityCertificationsQueryOptions } from '@/app/(client)/my-styles/-hooks/useEntityCertificationsQuery';
import { isEntityKindPath } from '@/app/(client)/my-styles/-hooks/useEntityDetail';
import { queryClient } from '@/lib/utils/queryClient';

export const Route = createFileRoute(
  '/(client)/my-styles/(pages)/(detail)/$kind/$id/certifications',
)({
  loader: ({ params }) =>
    queryClient.ensureQueryData(
      entityCertificationsQueryOptions(params.id, { page: 1, count: 50 }),
    ),
  component: CertificationsRoute,
});

function CertificationsRoute() {
  const { kind, id } = Route.useParams();
  const safeKind = isEntityKindPath(kind) ? kind : 'styles';
  return <EntityCertificationsTab kind={safeKind} entityId={id} />;
}
